<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
    <!-- <div class="visible-lg bmw-lg-videos-channels"> -->

  <div class="bmw-lg-videos-channels" (window:orientationchange)="screenRotate($event)">
    <div class="row bmw-no-gutter">
      <div class="col-lg-6 bmw-no-gutter">
        <div class="bmw-lg-videos-channels-title">
          Channels
        </div>
      </div>
      <div class="col-lg-6 bmw-no-gutter">
        <form class="input-group" name="findChannels">
          <input [disabled]="" type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Channel"
            name="videoChannel" [(ngModel)]="search4channel">
          <div class="input-group-btn">
            <button [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}'
              class="btn btn-default" type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="row bmw-no-gutter bmw-lg-videos-channels-list">
      <div *ngIf='!channelList'>{{serviceError}}</div>
      <div *ngFor="let channel of channelList | searchFilter: 'channelName': search4channel | loadMoreItems: moreItems">
        <div class="bmw-lg-video-channel">
          <div style="height: 125px">
            <div class="circle">{{channel.channelNumber}}</div>
            <div data-toggle='tooltip' title={{channel.channelName}} style="text-align: center; margin-top: 10px; font-size: 13px">{{channel.channelName.length > 23 ? channel.channelName.substr(0,20)+'...' : channel.channelName}}</div>
          </div>

          <div class="row bmw-no-gutter pointer" (click)='toggleChannelSubsciprtion(channel.channelNumber, channel.channelName)'>
            <div *ngIf="isChannelSubscribed(channel.channelNumber); then thenBlock else elseBlock"></div>
            <ng-template #thenBlock>
              <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}' class="bmw-lg-videos-subscribe-btn checked">
                <div class="col-lg-2 bmw-no-gutter">
                  <i class="material-icons">check_circle</i>
                </div>
                <div class="col-lg-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                  Subscribed
                </div>
              </div>
            </ng-template>
            <ng-template #elseBlock>
              <div class="bmw-lg-videos-subscribe-btn unchecked">
                <div class="col-lg-2 bmw-no-gutter">
                  <i class="material-icons">add_circle_outline</i>
                </div>
                <div class="col-lg-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                  Subscribe
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="row bmw-no-gutter bmw-lg-video-channel-buttons">
      <div class="bmw-video-channel-btn bmw-button-secondary pointer" (click)='moreItems = moreItems + 10'>
        <label style="margin-top: 5px">Show More</label>
      </div>
      <div class="pointer bmw-video-channel-btn bmw-button-primary" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}' (click)='applySubscriptionChanges()'>
        <label style="margin-top: 5px">Done</label>
      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md bmw-md-videos-channels"> -->
  <div class="bmw-md-videos-channels" (window:orientationchange)="screenRotate($event)">
    <div class="row bmw-no-gutter">
      <div class="col-md-6 bmw-no-gutter">
        <div class="bmw-lg-videos-channels-title">
          Channels
        </div>
      </div>
      <div class="col-md-6 bmw-no-gutter">
        <form class="input-group" name="findChannels">
          <input [disabled]="" type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Channel"
            name="videoChannel" [(ngModel)]="search4channel">
          <div class="input-group-btn">
            <button [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" :"#1c69d4"}' class="btn btn-default" type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="row bmw-no-gutter bmw-lg-videos-channels-list">
      <div *ngFor="let channel of channelList | searchFilter: 'channelName': search4channel | loadMoreItems: moreItems">
        <div class="bmw-lg-video-channel">
          <div style="height: 125px">
            <div class="circle">{{channel.channelNumber}}</div>
            <div data-toggle='tooltip' title={{channel.channelName}} style="text-align: center; margin-top: 10px; font-size: 13px">{{channel.channelName.length > 23 ? channel.channelName.substr(0,20)+'...' : channel.channelName}}</div>
          </div>

          <div class="row bmw-no-gutter pointer" (click)='toggleChannelSubsciprtion(channel.channelNumber, channel.channelName)'>
            <div *ngIf="isChannelSubscribed(channel.channelNumber); then thenBlock else elseBlock"></div>
            <ng-template #thenBlock>
              <div class="bmw-lg-videos-subscribe-btn unchecked">
                <div class="col-md-2 bmw-no-gutter">
                  <i class="material-icons">add_circle_outline</i>
                </div>
                <div class="col-md-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                  Subscribe
                </div>
              </div>
            </ng-template>
            <ng-template #elseBlock>
              <div class="bmw-lg-videos-subscribe-btn checked" [ngStyle]='{"background-color":(APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                <div class="col-md-2 bmw-no-gutter">
                  <i class="material-icons">check_circle</i>
                </div>
                <div class="col-md-10 bmw-no-gutter" style="font-size: 13px; padding-left: 6px">
                  Subscribe
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="row pointer bmw-no-gutter bmw-lg-video-channel-buttons">
      <div class="bmw-video-channel-btn bmw-button-secondary pointer">
        <label style="margin-top: 5px">Show More</label>
      </div>
      <div class="pointer bmw-video-channel-btn bmw-button-primary" (click)='applySubscriptionChanges()'>
        <label style="margin-top: 5px">Done</label>
      </div>
    </div>
  </div>
</div>

<!-- Tablet HTML -->

<div *ngIf='screenWidth >= 767 && screenWidth <= 991' >
  <div class="bmw-sm-videos-channels" (window:orientationchange)="screenRotate($event)">
    <div class="row bmw-no-gutter" style="padding-bottom: 18px; padding-top: 36px">
      <div class="col-sm-7 bmw-no-gutter bmw-sm-video-channels-title">Channels</div>
      <div class="col-sm-5 bmw-no-gutter">
        <form class="input-group" name="findChannels" style="width: 234px; padding-left:12px;padding-top:10px">
          <input [disabled]="" type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Channel"
            name="videoChannel" [(ngModel)]="search4channel">
          <div class="input-group-btn">
            <button [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' style="color: #fff" class="btn btn-default"
              type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf='!channelList'>{{serviceError}}</div>
    <div class="bmw-sm-videos-channels-list">
      <div class="row bmw-no-gutter bmw-sm-videos-channel" (click)='toggleChannelSubsciprtion(channel.channelNumber, channel.channelName)' *ngFor="let channel of channelList | searchFilter: 'channelName': search4channel | loadMoreItems: moreItems">
        <div class="col-sm-2 bmw-no-gutter circle" [ngStyle]="{'background-color':isChannelSubscribed(channel.channelNumber) && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : 
          isChannelSubscribed(channel.channelNumber) && (APP_SETTINGS.BMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : isChannelSubscribed(channel.channelNumber) && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#444444' }">
          {{channel.channelNumber}}
        </div>
        <div class="col-sm-9 bmw-no-gutter" style="padding-left:10px;padding-top: 1%;">
          <span>{{channel.channelName}}</span>
        </div>
        <div *ngIf='isChannelSubscribed(channel.channelNumber); then thenBlock else elseBlock'></div>
        <ng-template #thenBlock>
          <div [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="col-sm-1 bmw-no-gutter checked">
            <div>
              <i class="material-icons" style="line-height:2">check_circle</i>
            </div>
          </div>
        </ng-template>
        <ng-template #elseBlock>
          <div class="col-sm-1 bmw-no-gutter unchecked">
            <div>
              <i class="material-icons" style="line-height:2">add_circle_outline</i>
            </div>
          </div>
        </ng-template>
      </div>

    </div>
    <div class="row bmw-no-gutter" [ngClass]="{'mini-sm-video-channel-btn' : APP_SETTINGS.isMINI === 'true','rr-sm-video-channel-btn': APP_SETTINGS.isRollsRoyce === 'true', 'bmw-sm-video-channel-btn': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}">Show More</div>
    <a (click)='applySubscriptionChanges()'>
      <div [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="row bmw-no-gutter bmw-sm-video-channel-btn done">Done</div>
    </a>
  </div>
</div>

<!-- Mobile HTML -->

<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs bmw-xs-videos-channels"> -->
  <div class="bmw-xs-videos-channels" (window:orientationchange)="screenRotate($event)">
    <div class="row bmw-no-gutter" style="border-bottom: 1px solid #e6e6e6; padding-bottom: 18px">
      <div class="col-xs-5 bmw-no-gutter bmw-xs-video-channels-title">Channels</div>
      <div class="col-xs-7 bmw-no-gutter">
        <form class="input-group" name="findChannels">
          <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;" placeholder="Find Channel" name="videoChannel"
            [(ngModel)]="search4channel">
          <div class="input-group-btn">
            <button [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}' class="btn btn-default" type="submit">
              <i class="glyphicon glyphicon-search"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf='!channelList'>{{serviceError}}</div>
    <div class="bmw-xs-videos-channels-list">
      <div class="row bmw-no-gutter" (click)='toggleChannelSubsciprtion(channel.channelNumber, channel.channelName)' style="margin-top:10px" *ngFor="let channel of channelList | searchFilter: 'channelName': search4channel | loadMoreItems: moreItems">
        <div class="col-xs-2 bmw-no-gutter circle" [ngStyle]="{'background-color':isChannelSubscribed(channel.channelNumber) && (APP_SETTINGS.isMINI === 'true') ? '#bf1a22' : 
        isChannelSubscribed(channel.channelNumber) && (APP_SETTINGS.BMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true') ? '#1c69d4' : isChannelSubscribed(channel.channelNumber) && (APP_SETTINGS.isRollsRoyce === 'true') ? '#281432' : '#444444' }">
          {{channel.channelNumber}}
        </div>
        <div class="col-xs-9 bmw-no-gutter" style="padding-left:10px;padding-top: 2%;">
          <span>{{channel.channelName}}</span>
        </div>
        <div *ngIf='isChannelSubscribed(channel.channelNumber); then thenBlock else elseBlock' class="col-xs-1 bmw-no-gutter"></div>
        <ng-template #thenBlock>
          <div class="checked" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
            <div>
              <i class="material-icons">check_circle</i>
            </div>
          </div>
        </ng-template>
        <ng-template #elseBlock>
          <div class="unchecked">
            <div>
              <i class="material-icons">add_circle_outline</i>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="row bmw-no-gutter bmw-video-channel-btn">Show More</div>
    <a routerLink='../manage-subscription' (click)='applySubscriptionChanges()'>
      <div class="row bmw-no-gutter bmw-video-channel-btn done">Done</div>
    </a>
  </div>
</div>